import React from 'react';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
import { makeStyles } from '../../theme';
import * as componentStyling from '../styling';

/**
 * Use `theme settings` as much as possible instead of hard-coded values.
 * More theme settings on: https://material-ui.com/customization/theming/
 */
const styles = makeStyles(
	({ palette, spacing }) => ({
		spacing: {
			marginBottom: spacing(2)
		},
		generalErrMsg: {
			color: palette.error.main,
			marginBottom: spacing(2.5)
		}
	})
);

const Text = React.memo(
	({children, className, variant='body1', component, error=false, ...props}) => {
		const classes = styles();
		return (
			<Typography
				variant={variant}
				component={component}
				{...props}
				className={cx(
					component !== 'span' && classes.spacing,
					error && classes.generalErrMsg,
					componentStyling.Text,
					className
				)}
				>
				{children}
			</Typography>
		);
	}
);

export default Text;